class DataHelper {
	static get PAYMENT_METHODS() {
		return {
			0: 'Csekk',
			1: 'Átutalás',
			2: 'Csoportos beszedés',
			3: 'Online bankkártyás díjfizetés',
		};
	}

	static get PAYMENT_FREQUENCY() {
		return {
			0: 'Havi',
			1: 'Negyedéves',
			2: 'Féléves',
			3: 'Éves',
		};
	}

	static get OWNERSHIP() {
		return {
			0: 'Saját Tulajdon (saját használatban)',
			1: 'Saját tulajdon (bérbeadva)',
			2: 'Bérlemény',
		};
	}

	static get REAL_ESTATE_TYPE() {
		return {
			0: 'Társasházi lakás',
			1: 'Családi ház',
			2: 'Sorház',
			3: 'Ikerház',
		};
	}

	static get WALL_TYPE() {
		return {
			0: 'Tégla',
			1: 'Fa',
			2: 'Beton',
			3: 'Kő',
			4: 'Panel',
			5: 'Könnyűszerkezetes',
			6: 'Vályog',
			7: 'Vegyes (vályog és szilárd)',
		};
	}

	static get ROOF_TYPE() {
		return {
			0: 'Cserép',
			5: 'Bitumenes - Lapostető',
			1: 'Pala',
			2: 'Nád',
			3: 'Fazsindely',
			4: 'Szalma',
			6: 'Műanyag',
			7: 'Fém',
		};
	}

	static get CURRENCY() {
		return {
			HUF: 'HUF',
			CHF: 'CHF',
			EUR: 'EUR',
			USD: 'USD',
		};
	}

	static get BUILDING_TYPE() {
		return {
			100: 'Medence',
			101: 'Kerítés',
			102: 'Egyéb kerti építmény',
		};
	}

	static getData(type, value) {
		return DataHelper[type][value];
	}
}

export default DataHelper;
